import React from 'react';

const SnackMsg = props => {
    if (props.timeout && props.isOpen) {
        setTimeout(props.onClose, props.timeout);
    }

    var cl = 'snackbar' + (props.isOpen ? ' active' : ' inactive');
    var typeCl = 'snackbar-type ' + 'snackbar-' + props.type;

    var typeElmt = props.type ?
        (<span className={typeCl}>
            {props.type.charAt(0).toUpperCase() +
                props.type.slice(1)}: </span>) :
        null
    ;

    return <div className={cl}>
        {typeElmt}
        {props.message}

        {props.timeout === undefined || props.timeout === null ?
            <button type="button" className="close" aria-label="Close"
                onClick={props.onClose}
            >
                <i className="fa fa-times-circle" aria-hidden="true"></i>
            </button> :
            null
        }
    </div>;
}

export default SnackMsg
